import common from '@/services/common'

export default {
  async getBanners() {
    return await common.execute('get', `/api/banners/v1/state`)
  },
  async updateBanners(data) {
    return await common.execute('post', '/api/banners/v1/state', data)
  },
  async promote(data) {
    return await common.execute('post', '/api/banners/v1/promote', data)
  },
}
